var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHealthtesting(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 470,
    height: 470,
    viewBox: "0 0 470 470",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M287.208 469.123L286.496 468.857C286.339 468.798 270.762 462.852 263.465 449.37C256.168 435.887 259.741 419.653 259.778 419.491L259.946 418.752L260.658 419.018C260.815 419.077 276.391 425.023 283.688 438.505C290.986 451.988 287.413 468.221 287.376 468.383L287.208 469.123ZM264.634 448.742C270.803 460.142 283.112 465.985 286.231 467.319C286.824 463.988 288.684 450.521 282.52 439.133C276.357 427.746 264.043 421.893 260.922 420.556C260.329 423.888 258.47 437.354 264.634 448.742Z",
    fill: "var(--color-primary)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M269.039 444.64C282.153 452.5 287.203 468.113 287.203 468.113C287.203 468.113 270.992 470.982 257.879 463.122C244.765 455.261 239.715 439.648 239.715 439.648C239.715 439.648 255.926 436.78 269.039 444.64Z",
    fill: "var(--color-ternary)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M470.001 223.544H74.8008V0H470.001V223.544Z",
    fill: "#262626"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M470.001 223.544H74.8008V0H470.001V223.544ZM79.5411 218.822H465.26V4.72277H79.5411V218.822Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M399.623 72.2871H145.186V78.6256H399.623V72.2871Z",
    fill: "url(#paint0_linear_1_7603)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M399.623 108.494H145.186V114.833H399.623V108.494Z",
    fill: "url(#paint1_linear_1_7603)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M399.623 144.702H145.186V151.041H399.623V144.702Z",
    fill: "url(#paint2_linear_1_7603)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M188.098 62.8613H177.037V88.0494H188.098V62.8613Z",
    fill: "url(#paint3_linear_1_7603)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M266.313 99.2871H255.252V124.475H266.313V99.2871Z",
    fill: "url(#paint4_linear_1_7603)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M364.277 135.495H353.217V160.683H364.277V135.495Z",
    fill: "url(#paint5_linear_1_7603)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M230.549 257.262H77.2383V263.6H230.549V257.262Z",
    fill: "#EBEBEB"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M230.549 278.515H77.2383V284.853H230.549V278.515Z",
    fill: "#EBEBEB"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M152.334 299.767H77.2383V306.105H152.334V299.767Z",
    fill: "#EBEBEB"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M224.439 346.336H177.826V299.896H224.439V346.336Z",
    fill: "var(--color-ternary)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M224.439 346.336H177.826V299.896H224.439V346.336ZM179.406 344.762H222.859V301.47H179.406V344.762Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M467.775 346.336H421.162V299.896H467.775V346.336Z",
    fill: "var(--color-primary)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M467.775 346.336H421.162V299.896H467.775V346.336ZM422.742 344.762H466.195V301.47H422.742V344.762Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M199.058 329.96L193.469 322.797L196.719 320.278L199.366 323.669L208.307 314.266L211.298 317.087L199.058 329.96Z",
    fill: "#EBEBEB"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M467.567 257.262H314.256V263.6H467.567V257.262Z",
    fill: "#EBEBEB"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M467.567 278.515H314.256V284.853H467.567V278.515Z",
    fill: "#EBEBEB"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M389.352 299.767H314.256V306.105H389.352V299.767Z",
    fill: "#EBEBEB"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5359 292.064C79.2795 291.486 79.9006 290.767 80.3632 289.948C80.8258 289.13 81.1208 288.227 81.231 287.294C81.3413 286.361 81.2646 285.415 81.0054 284.512C80.7462 283.609 80.3097 282.765 79.7211 282.031C79.4745 281.724 79.2033 281.437 78.9103 281.173L76.7859 188.001L61.4531 190.729L68.3785 281.94C67.38 283.199 66.8381 284.758 66.841 286.363C66.8439 287.968 67.3914 289.525 68.3946 290.781C69.5753 292.282 71.3022 293.258 73.2007 293.498C75.0992 293.739 77.0162 293.223 78.5359 292.064Z",
    fill: "#EBEBEB"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M74.302 170.805C74.1163 170.761 73.9293 170.721 73.7396 170.685C72.2433 170.405 70.705 170.44 69.223 170.787C67.741 171.133 66.348 171.784 65.1331 172.698C63.9182 173.612 62.9082 174.769 62.1678 176.094C61.4273 177.419 60.9728 178.884 60.8331 180.394L60.4062 185.013L62.0812 234.851L78.3976 234.761L81.8504 193.092L82.6311 182.167C82.8154 179.598 82.0798 177.047 80.5549 174.967C79.03 172.887 76.8146 171.412 74.302 170.805Z",
    fill: "black"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M139.921 461.27L148.963 461.269L153.263 426.527H139.92L139.921 461.27Z",
    fill: "#EBEBEB"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M137.617 458.108L155.421 458.107C158.431 458.108 161.317 459.299 163.445 461.418C165.573 463.538 166.768 466.414 166.768 469.412V469.779L137.618 469.78L137.617 458.108Z",
    fill: "black"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M5.81055 450.729L13.9931 454.558L32.7117 424.934L20.6342 419.283L5.81055 450.729Z",
    fill: "#EBEBEB"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M4.98017 447.088L21.0955 454.629C23.819 455.903 25.9235 458.204 26.9448 461.024C27.9661 463.844 27.8213 466.953 26.5421 469.667L26.3854 469.999L0 457.653L4.98017 447.088Z",
    fill: "black"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M95.7491 152.785C101.345 142.587 97.5827 129.801 87.347 124.226C77.1112 118.652 64.2775 122.4 58.6821 132.598C53.0867 142.795 56.8485 155.582 67.0843 161.156C77.3201 166.731 90.1538 162.983 95.7491 152.785Z",
    fill: "#EBEBEB"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M83.32 173.246L64.1105 167.617L51.2288 200.04L75.1842 249.35L75.6362 258.131C75.6362 258.131 58.7835 278.703 57.3306 308.792L51.0028 326.129L43.545 342.566L6.39453 434.409L24.9297 446.057L98.8689 310.541L139.076 450.603L155.938 451.543L140.216 274.46L122.822 239.515L115.123 222.185C115.123 222.185 123.855 203.203 106.95 194.308L83.32 173.246Z",
    fill: "var(--color-ternary)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M99.7217 119.589C94.4996 115.305 86.022 115.712 80.1672 119.501C76.676 117.483 72.6305 116.623 68.6163 117.047C64.602 117.47 60.8273 119.156 57.8383 121.859C52.0013 127.375 50.474 136.896 53.5876 144.308C54.8905 148.14 55.2301 152.232 54.5767 156.225C53.9233 160.218 52.2969 163.991 49.8398 167.212C55.5013 167.542 61.1625 167.871 66.8375 167.966C68.1538 167.137 69.3699 166.159 70.4617 165.053C72.7189 167.474 74.9922 168.718 75.4451 168.643C81.5129 167.88 87.6516 167.859 93.7246 168.58C90.8437 159.454 87.9628 150.327 84.4284 142.247C90.3804 145.45 98.6207 143.425 102.396 137.832C106.171 132.24 104.944 123.872 99.7217 119.589Z",
    fill: "black"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M123.033 292.626C123.619 291.89 124.053 291.046 124.309 290.141C124.566 289.237 124.639 288.291 124.526 287.358C124.413 286.426 124.115 285.524 123.65 284.707C123.185 283.89 122.562 283.172 121.817 282.597C121.504 282.356 121.173 282.14 120.826 281.952L96.7708 191.891L82.5117 198.134L110.77 285.165C110.097 286.623 109.938 288.265 110.32 289.825C110.702 291.384 111.601 292.769 112.873 293.755C114.375 294.937 116.283 295.481 118.185 295.27C120.087 295.059 121.829 294.109 123.033 292.626Z",
    fill: "#EBEBEB"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2951 175.759C90.1041 175.759 89.9129 175.764 89.7201 175.774C88.1998 175.852 86.7128 176.246 85.3541 176.93C83.9955 177.615 82.7953 178.574 81.8301 179.747C80.865 180.92 80.1563 182.281 79.7494 183.742C79.3425 185.204 79.2464 186.734 79.4672 188.234L80.1422 192.823L93.533 240.872L109.371 236.962L102.892 195.652L101.072 184.851C100.645 182.31 99.3279 180.003 97.3548 178.339C95.3818 176.674 92.8805 175.76 90.2951 175.759Z",
    fill: "black"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M330.92 469.915H213.993C213.784 469.915 213.583 469.832 213.434 469.685C213.286 469.537 213.203 469.337 213.203 469.128C213.203 468.919 213.286 468.719 213.434 468.571C213.583 468.424 213.784 468.341 213.993 468.341H330.92C331.13 468.341 331.331 468.424 331.479 468.571C331.627 468.719 331.71 468.919 331.71 469.128C331.71 469.337 331.627 469.537 331.479 469.685C331.331 469.832 331.13 469.915 330.92 469.915Z",
    fill: "#EBEBEB"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_7603",
    x1: 170.629,
    y1: 77.3428,
    x2: 171.16,
    y2: 64.897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--color-second)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E73636"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_7603",
    x1: 170.629,
    y1: 113.55,
    x2: 171.16,
    y2: 101.104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--color-second)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E73636"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_7603",
    x1: 170.629,
    y1: 149.758,
    x2: 171.16,
    y2: 137.312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--color-second)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E73636"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_7603",
    x1: 178.143,
    y1: 82.9518,
    x2: 190.069,
    y2: 79.8927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--color-second)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E73636"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_7603",
    x1: 256.358,
    y1: 119.378,
    x2: 268.283,
    y2: 116.318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--color-second)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E73636"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1_7603",
    x1: 354.323,
    y1: 155.586,
    x2: 366.248,
    y2: 152.526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--color-second)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E73636"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthtesting);
export default __webpack_public_path__ + "static/media/HEALTHTESTING.df574d44fd690f65c2aab3c91777544a.svg";
export { ForwardRef as ReactComponent };